import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/storage';
import 'firebase/functions';
import config from './config';

let firebaseApp;

if (!firebase.apps.length) {
  firebaseApp = firebase.initializeApp(config);
}

const firebaseDb = firebase.firestore(firebaseApp);
const firebaseAuth = firebase.auth(firebaseApp);
const firebaseStorage = firebase.storage(firebaseApp);
const firebaseFunction = firebase.functions(firebaseApp)

export { firebaseApp, firebaseAuth, firebaseDb, firebaseStorage, firebaseFunction };
